import { create } from 'zustand';
import { persist } from 'zustand/middleware';

/**
 * Persisted view-mode preference for the PDPs list (CLAUDE.md §2.3), mirroring
 * the CRM/Employees list stores. Search/status filters live in page-local
 * server-driven query state and stay out of the store — those are not durable
 * user prefs.
 */
export type PdpsViewMode = 'table' | 'list' | 'cards' | 'grouped';

export const PDPS_VIEW_MODES: PdpsViewMode[] = ['table', 'list', 'cards', 'grouped'];

interface PdpsUiState {
  view: PdpsViewMode;
  setView: (view: PdpsViewMode) => void;
  /** Current DRF `OrderingFilter` value (e.g. `-period`). Session-only. */
  ordering: string | undefined;
  setOrdering: (ordering: string | undefined) => void;
}

export const usePdpsUi = create<PdpsUiState>()(
  persist(
    (set) => ({
      view: 'table',
      setView: (view) => set({ view }),
      ordering: undefined,
      setOrdering: (ordering) => set({ ordering }),
    }),
    {
      name: 'hrm.pdps:ui',
      // Only the view mode is durable — ordering stays ephemeral so refreshes
      // return to a clean default.
      partialize: (state) => ({ view: state.view }),
    },
  ),
);
